import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faCalendarPlus,
  faCalendarMinus,
} from "@fortawesome/free-solid-svg-icons";
import { fetchJobs } from "../redux/actions/jobs";
import UsePagination from "../components/custom/UsePagination";

function CareerSection() {
  const dispatch = useDispatch();
  const { items: jobs, status, error } = useSelector((state) => state.jobs);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchJobs());
    }
  }, [status, dispatch]);

  const itemsPerPage = 5;
  const approvedJobs = jobs.filter((job) => job.status === "approve");
  const {
    currentItems,
    totalPages,
    currentPage,
    paginate,
    nextPage,
    prevPage,
  } = UsePagination(approvedJobs, itemsPerPage);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (status === "failed") {
    return (
      <div className="w-full h-1/3 mt-5 mb-5">
        <div className="bg-white py-10 dark:bg-dark">
          <div className="container">
            <div className="flex w-full rounded-lg border-l-[6px] border-[#F55F58] bg-[#FFF1F0] p-4 dark:bg-[#575558] md:p-[30px]">
              <div className="mr-5 text-[#F55F58]">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  className="fill-current"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9999 2.83366C9.57774 2.83366 3.83325 8.57815 3.83325 16.0003C3.83325 23.4225 9.57774 29.167 16.9999 29.167C24.4221 29.167 30.1666 23.4225 30.1666 16.0003C30.1666 8.57815 24.4221 2.83366 16.9999 2.83366ZM0.333252 16.0003C0.333252 7.54021 7.53979 0.33366 15.9999 0.33366C24.46 0.33366 31.6666 7.54021 31.6666 16.0003C31.6666 24.4604 24.46 31.667 15.9999 31.667C7.53979 31.667 0.333252 24.4604 0.333252 16.0003ZM17.8333 8.83366C17.8333 8.18138 17.3182 7.66699 16.6666 7.66699C16.0143 7.66699 15.4999 8.18138 15.4999 8.83366V18.0846C15.4999 18.7369 16.0143 19.2513 16.6666 19.2513C17.3182 19.2513 17.8333 18.7369 17.8333 18.0846V8.83366ZM16.6666 24.5003C17.3182 24.5003 17.8333 23.9859 17.8333 23.3337C17.8333 22.6814 17.3182 22.167 16.6666 22.167C16.0143 22.167 15.4999 22.6814 15.4999 23.3337C15.4999 23.9859 16.0143 24.5003 16.6666 24.5003Z"
                  ></path>
                </svg>
              </div>
              <div className="w-full mb-5">
                <div className="mb-2 flex items-center justify-between">
                  <h5 className="text-lg font-medium leading-tight text-[#CD3D3A]">
                    {error}
                  </h5>
                </div>
                <p className="text-base leading-relaxed text-body-color">
                  Please try again later.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (status === "succeeded" && approvedJobs.length === 0) {
    return (
      <div className="text-center mb-5 mt-5">
        <h1>No approved jobs available</h1>
      </div>
    );
  }

  return (
    <section className="career-section pt_120 pb_90">
      <div
        className="bg-layer"
        style={{
          backgroundImage: "url(assets/images/background/career-bg.jpg)",
        }}
      ></div>
      <div className="auto-container">
        <div className="sec-title centred mb_70">
          <h6>Current Jobs</h6>
          <h2>Current Job Positions</h2>
        </div>
        <div className="inner-container">
          {currentItems.map((job) => (
            <div className="career-block-one" key={job._id}>
              <div className="inner-box">
                <div className="author-box">
                  <figure className="thumb-box">
                    <img src={job.jobImage} alt={job.jobTitle} />
                  </figure>
                  <div className="text-box">
                    <h3>{job.jobTitle}</h3>
                    <span className="designation">{job.department}</span>
                  </div>
                </div>
                <ul className="info-box clearfix">
                  <li>
                    <FontAwesomeIcon
                      icon={faMapMarkerAlt}
                      className="jobIcon1"
                    />{" "}
                    {job.location}
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCalendarPlus}
                      className="jobIcon1"
                    />{" "}
                    Posted: {new Date(job.postedDate).toLocaleDateString()}
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCalendarMinus}
                      className="jobIcon2"
                    />{" "}
                    Expires: {new Date(job.expireDate).toLocaleDateString()}
                  </li>
                </ul>
                <div className="btn-box">
                  <Link to={`/career/${job._id}`}>Apply Now</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        {approvedJobs.length > itemsPerPage && (
          <div className="pagination-wrapper centred pt_50">
            <ul className="pagination">
              <li>
                <Link
                  to="#"
                  onClick={prevPage}
                  className={currentPage === 1 ? "disabled" : ""}
                >
                  <i className="icon-40"></i>
                </Link>
              </li>
              {[...Array(totalPages).keys()].map((number) => (
                <li key={number + 1}>
                  <Link
                    to="#"
                    onClick={() => paginate(number + 1)}
                    className={currentPage === number + 1 ? "current" : ""}
                  >
                    {number + 1}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="#"
                  onClick={nextPage}
                  className={currentPage === totalPages ? "disabled" : ""}
                >
                  <i className="icon-41"></i>
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </section>
  );
}

export default CareerSection;
